module.exports = __webpack_public_path__ + "static/media/Finnovex-South-Africa-2024.b69cd406.png";